import Vue from "vue"
import Vuex from "vuex"
import axios from "axios"
import { router } from "./router"

Vue.use(Vuex)

const store = new Vuex.Store({
    state: {
        web_url: "https://www.apidosya.aslanyazilimm.com/",
        base_url: "https://www.apidosya.aslanyazilimm.com/DosyaApi/",
        img_base_url: "https://www.file.dosya.aslanyazilimm.com/AllImageFile/",
        pdf_upload_url: "https://www.file.dosya.aslanyazilimm.com/UploadImg/user_upload_pdf.php",
        img_upload_url: "https://www.file.dosya.aslanyazilimm.com/UploadImg/user_upload_img.php",
        img_upload_urlAdminpp: "https://www.file.dosya.aslanyazilimm.com/UploadImg/admin_upload_imgpp.php",
        pdf_upload_url: "https://www.file.dosya.aslanyazilimm.com/UploadImg/userUploadPdf.php",
        img_upload_admin_default: "https://www.file.dosya.aslanyazilimm.com/UploadImg/admin_default_img.php",
        img_upload_sigup: "https://www.file.dosya.aslanyazilimm.com/UploadImg/user_signup_img.php",
        token: "",
        admin_token: "",
        id: "",
        role: "",
        loginResult: false
    },
    mutations: {
        setToken(state, getdata) {
            state.id = getdata.id
            state.token = getdata.token
            state.admin_token = getdata.token

        },
        clearToken(state) {
            state.id = ""
            state.token = ""
            state.admin_token = ""
        }
    },


    actions: {
        login({ commit, dispatch, state }, data) {
            let dataUrl = state.base_url + "Admin/login.php?key=123"

            var datas = {
                email: data.email,
                password: data.password
            };

            return axios.post(dataUrl, JSON.stringify(datas),

            ).then(response => {

                if (response.data.result) {
                    console.log(response)
                    this.state.loginResult = true;
                    if (response.data.role == "admin") {
                        console.log("admin girişi yapıldı")
                        var senddata = {
                            id: response.data.dataAdmin.id,
                            admin_token: response.data.admin_token,
                            role: response.data.role,
                            sectionsId: response.data.dataAdmin.sectionsId,
                        }
                        commit("setToken", senddata)
                        localStorage.setItem("id", senddata.id)
                        localStorage.setItem("sectionsId", senddata.sectionsId)
                        localStorage.setItem("role", senddata.role)
                        localStorage.setItem("admin_token", senddata.admin_token)
                    } else {
                        var senddata = {
                            id: response.data.data.id,
                            token: response.data.token,
                        }
                        commit("setToken", senddata)
                        localStorage.setItem("id", response.data.data.id)
                        localStorage.setItem("sectionsId", response.data.data.sectionsId)
                        localStorage.setItem("token", response.data.token)
                    }


                } else {
                    console.log("hatalı giriş");
                }

            }).catch(err => {
                console.log(err.response);
            });


        },

        logout({ commit }) {

            commit("clearToken")

            localStorage.removeItem("id")
            localStorage.removeItem("token")
            localStorage.removeItem("admin_token")
            localStorage.removeItem("role")
            localStorage.removeItem("sectionsId")
            location.reload();
        },
        lockScreen({ commit }) {

            commit("clearToken")
            localStorage.removeItem("sectionsId")
            localStorage.removeItem("id")
            localStorage.removeItem("token")
            localStorage.removeItem("admin_token")
            localStorage.removeItem("role")
            console.log("windowlocation store");
        }

    },

    getters: {
        isLogin(state) {
            return (localStorage.getItem("id") !== null && localStorage.getItem("token") !== null) || (localStorage.getItem("admin_token") !== null && localStorage.getItem("role") !== null)
        },
        getUser(state) {

            var result = {
                id: state.id,
                token: state.token,
                admin_token: state.admin_token,
                role: state.role,
            }

            return result
        }
    }
})

export default store


// WEBPACK FOOTER //
// ./src/store.js